export const API_URL = process.env.GATSBY_API_URL;
export const ADMIN_URL = process.env.GATSBY_ADMIN_URL;
export const LP_BASE_URL = process.env.GATSBY_LP_BASE_URL;
export const SITE_TITLE = process.env.GATSBY_SITE_TITLE;
export const URL_LINK_LETS = process.env.GATSBY_URL_LINK_LETS;
export const URL_LINK_LASA = process.env.GATSBY_URL_LINK_LASA;
export const URL_LINK_AME = process.env.GATSBY_URL_LINK_AME;

export const playStoreUrl = 'https://play.google.com/store/apps/details?id=com.allyaapp&hl=pt_BR&showAllReviews=true';
export const appStoreUrl = 'https://apps.apple.com/br/app/allya/id1398933563';
export const dynamicStoreUrl = 'http://onelink.to/fhva5b';
